<template>
  <div class="void-modal">
    <div class="modal-header">
      <h3>Void Transaction</h3>
    </div>

    <div class="modal-body">
      <p>Are you sure you want to void this transaction?</p>

      <div class="transaction-details">
        <div class="detail-row">
          <span class="label">Transaction ID:</span>
          <span class="value">{{ transaction?.id }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Amount:</span>
          <span class="value">${{ parseFloat(transaction?.amount || 0).toFixed(2) }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Type:</span>
          <span class="value">{{ transaction?.type }}</span>
        </div>
      </div>

      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>

    <div class="modal-footer">
      <base-button
        variant="secondary"
        @click="$emit('close')"
        :disabled="processing"
      >
        Cancel
      </base-button>
      <base-button
        variant="danger"
        @click="processVoid"
        :disabled="processing"
      >
        {{ processing ? 'Processing...' : 'Void Transaction' }}
      </base-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import BaseButton from '@/components/base/BaseButton.vue';
import useService from '@/composables/common/services';
const { apiService } = useService();

const props = defineProps({
  transaction: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update', 'close']);

const processing = ref(false);
const errorMessage = ref('');

async function processVoid() {
  processing.value = true;
  errorMessage.value = '';

  // Determine the appropriate endpoint based on transaction type
  const isAch = ['debit', 'ach'].includes(props.transaction.type);
  const endpoint = isAch ? 'api/void' : 'api/void';

  const response = await apiService.post(endpoint, {
    id: props.transaction.id
  });

  if (response?.status) {
    emit('update');
    emit('close');
  } else {
    errorMessage.value = response?.data?.message || 'Failed to void transaction';
  }

  processing.value = false;
}
</script>

<style lang="scss" scoped>
.void-modal {
  padding: 20px;

  .modal-header {
    margin-bottom: 20px;

    h3 {
      margin: 0;
      font-size: 20px;
      color: #333;
    }
  }

  .modal-body {
    margin-bottom: 20px;

    .transaction-details {
      margin: 20px 0;
      padding: 15px;
      background: #f5f5f5;
      border-radius: 4px;

      .detail-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          font-weight: 600;
          color: #666;
        }

        .value {
          color: #333;
        }
      }
    }

    .error-message {
      color: #d32f2f;
      padding: 10px;
      background: #ffebee;
      border-radius: 4px;
      margin-top: 15px;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>